module.exports = __webpack_public_path__ + "img/floor_plan.5830968.svg";